import { ColorMap, colorTools } from '@codeleap/styles'
import { capitalize } from '@codeleap/styles/src/lib/utils'

type GenerateColorsArgs = {
  primary: string
  baseColors: {
    [x: string]: string
  }
  draft: {
    [x: string]: string
  }
}
const lightness = {
    '50': 95,   
    '100': 87,  
    '200': 79,  
    '300': 71,  
    '400': 63,  
    '500': null, // To be replaced with original color lightness
    '600': 39,  
    '700': 31,  
    '800': 23,  
    '900': 15   
}


const shades = [50, 200, 300, 500]

const variantOpacityScheme = {
  heading: '1.00',
  headingSubtle: '0.75',
  caption: '0.50',
  captionSubtle: '0.25',
}

function getTextColor(bgColor: string): string {
  const rgbMatch = bgColor.match(/\d+/g)
  if (!rgbMatch) return 'rgba(0, 0, 0, 1)'
  
  const [r, g, b] = rgbMatch.map(Number)
  
  const [rs, gs, bs] = [r, g, b].map(val => {
    const channel = val / 255
    return channel <= 0.03928 
      ? channel / 12.92 
      : Math.pow((channel + 0.055) / 1.055, 2.4)
  })
  
  const luminance = 0.2126 * rs + 0.7152 * gs + 0.0722 * bs
  
  return luminance > 0.5 
    ? 'black' 
    : 'white'
}

function generateTextColor(color: string, prefix: string, variant: string, colorMap: ColorMap) {
  const capitalizedPrefix = capitalize(prefix)
  const capitalizedVariant = capitalize(variant)

  let textColors: ColorMap = {}

  shades.forEach(shade => {
    Object.entries(variantOpacityScheme).forEach(([opacityVariant, opacity]) => {
      const color = colorMap[`${prefix}${capitalizedVariant}${shade}`]
      const baseTextColor = getTextColor(color)
      
      const textKey = `on${capitalizedPrefix}${capitalizedVariant}${shade}${capitalize(opacityVariant)}`
      const rgbColor = baseTextColor == 'black' ? '0, 0, 0' : '255, 255, 255'
      
      textColors[textKey] = `rgba(${rgbColor}, ${opacity})`
    })
  })


  return textColors
}

export const generateColors = (args: GenerateColorsArgs) => {
  const { primary, baseColors, draft } = args
  
  const primaryHSL = colorTools.hexToHSL(primary)
  const primaryLightness = { ...lightness, '500': primaryHSL.l }
  const primaryColors = colorTools.generateColorScheme(primary, 'primary', primaryLightness)
  const textColors = generateTextColor(primary, 'primary', 'solid', primaryColors)

  const overrides = {
    ...primaryColors,
    ...textColors
  }

  const colorBase = {
    ...baseColors,
    ...overrides
  }


  const colorScheme = Object.entries(draft).reduce((acc, [key, keyColor]) => {
    acc[key] = colorBase[keyColor]
    return acc
  }, {})

 

  return [colorScheme, overrides]
}